module.exports = __webpack_public_path__ + "static/img/Varner-Auto-Laptop.e978708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Varner-Auto-Laptop.png
// module id = n90F
// module chunks = 1